import React, { useEffect, useState } from "react";
import { getDriverLicence } from "../../api/apiGetrequest";
import TableHeader from "../../Components/DataTable/TableHeader";
import TruckLoader from "../../Components/ProgressBar/Loader";
import LicenseForm from "./AddDriverDL";
import LicenseDetailsView from "./ViewDL";

const details = JSON.parse(localStorage.getItem("user"));

const ElegantClock = () => {
  const [time, setTime] = useState(new Date());
  const [licenseStatus, setLicenseStatus] = useState("expired"); // Default to "expired"
  const [daysUntilLock, setDaysUntilLock] = useState(3); // Default to 3 days
  const [adddl, setAdddl] = useState(null);
  const [dlview, setDlview] = useState(null);
  const [licence, setLicence] = useState({});
  const [loading, setLoading] = useState(true); // Loading state

  const handleAddNewLicense = () => {
    setAdddl(true);
  };

  const handleLicenseView = () => {
    setDlview(true);
  };

  useEffect(() => {
    if (licenseStatus === "expired") {
      const interval = setInterval(() => {
        setDaysUntilLock((prev) => (prev > 0 ? prev - 1 : 0));
      }, 86400000); // 24 hours in milliseconds
      return () => clearInterval(interval);
    }
  }, [licenseStatus]);

  const fetchData = async () => {
    try {
      const { result } = await getDriverLicence(details?.data?.userID);

      if (result && result.length > 0) {
        const licenseData = result[0];
        setLicence(licenseData);

        const renewalDate = new Date(licenseData.NextRenewalDate);
        const currentDate = new Date();
        const timeDifference = renewalDate - currentDate;
        const daysDifference = Math.ceil(
          timeDifference / (1000 * 60 * 60 * 24)
        );

        setDaysUntilLock(daysDifference > 0 ? daysDifference : 0);

        // Determine the license status based on StatusID and NextRenewalDate
        if (licenseData.StatusID === 2) {
          setLicenseStatus("Pending Approval");
        } else if (licenseData.NextRenewalDate < currentDate) {
          setLicenseStatus("Expired");
        } else if (daysDifference <= 7) {
          setLicenseStatus(`Due in ${daysDifference} Days`);
        } else {
          setLicenseStatus("Active");
        }
      } else {
        console.error("No license data found.");
        setLicence(null);
        setDaysUntilLock(0);
        setLicenseStatus("No License Found");
      }
    } catch (error) {
      console.error("Error fetching license data:", error);
      setLicence(null);
      setDaysUntilLock(0);
      setLicenseStatus("Error Fetching Data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (details?.data?.userID) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [details?.data?.userID]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "#fff" }}>
        <TruckLoader />
        Loading...
      </div>
    ); // Show loading message
  }

  if (adddl) {
    return (
      <>
        <TableHeader
          title="Repair Tracker"
          showAddButton={false}
          showBackButton={adddl}
          onBack={() => setAdddl(!adddl)}
          // onAdd={() => setIsAddingRepair(!isAddingRepair)}
          showPrintButton={false}
          showExcelButton={false}
          showPdfButton={false}
        />
        <LicenseForm
          licence={licence}
          fetchData={fetchData}
          DriverID={details?.data?.userID}
        />
      </>
    );
  }

  if (dlview) {
    return (
      <>
        <TableHeader
          title="License Details"
          showAddButton={false}
          showBackButton={true}
          onBack={() => setDlview(!dlview)}
          // onAdd={() => setIsAddingRepair(!isAddingRepair)}
          showPrintButton={false}
          showExcelButton={false}
          showPdfButton={false}
        />
        <LicenseDetailsView license={licence} />;
      </>
    );
  }

  const seconds = time.getSeconds();
  const minutes = time.getMinutes();
  const hours = time.getHours();
  const dayOfWeek = time.toLocaleString("en-US", { weekday: "long" });
  const date = time.toLocaleString("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const secondAngle = (seconds / 60) * 360;
  const minuteAngle = (minutes / 60) * 360 + (seconds / 60) * 6;
  const hourAngle = (hours % 12) * 30 + (minutes / 60) * 30;

  // Define all radius measurements
  const CLOCK_SIZE = 300;
  const OUTER_RADIUS = CLOCK_SIZE / 2;
  const NUMBER_RADIUS = OUTER_RADIUS * 0.75;
  const MARKER_START_RADIUS = OUTER_RADIUS * 0.95;

  // Generate hour numbers
  const hourNumbers = [];
  for (let i = 1; i <= 12; i++) {
    const angle = ((i / 12) * 360 - 90) * (Math.PI / 180);
    const x = Math.cos(angle) * NUMBER_RADIUS;
    const y = Math.sin(angle) * NUMBER_RADIUS;

    hourNumbers.push(
      <div
        key={i}
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
          color: "#94a3b8",
          fontSize: "16px",
          fontWeight: "500",
        }}
      >
        {i}
      </div>
    );
  }

  // Generate minute markers
  const minuteMarkers = [];
  for (let i = 0; i < 60; i++) {
    const isHourMark = i % 5 === 0;
    const angle = i * 6;
    const markerHeight = isHourMark ? 15 : 8;

    minuteMarkers.push(
      <div
        key={i}
        style={{
          position: "absolute",
          width: isHourMark ? "2px" : "1px",
          height: `${markerHeight}px`,
          backgroundColor: isHourMark ? "#94a3b8" : "#64748b",
          left: "50%",
          top: "50%",
          transformOrigin: "50% 50%",
          transform: `translate(-50%, -50%) rotate(${angle}deg) translateY(-${MARKER_START_RADIUS}px)`,
        }}
      />
    );
  }

  // Base styles
  const containerStyles = {
    minHeight: "100vh",
    background: "linear-gradient(to bottom, #0f172a, #1e293b)",
    color: "white",
    padding: "20px",
  };

  const clockFaceStyles = {
    position: "relative",
    width: `${CLOCK_SIZE}px`,
    height: `${CLOCK_SIZE}px`,
    margin: "0 auto",
  };

  return (
    <div style={containerStyles}>
      {/* Clock Face */}
      <div style={clockFaceStyles}>
        {/* Outer ring */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            background:
              "linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(167, 139, 250, 0.2))",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(12px)",
          }}
        >
          {/* Inner clock face */}
          <div
            style={{
              position: "absolute",
              inset: "16px",
              borderRadius: "50%",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(8px)",
            }}
          >
            {minuteMarkers}
            {hourNumbers}

            {/* Hour Hand */}
            <div
              style={{
                position: "absolute",
                width: "6px",
                height: `${OUTER_RADIUS * 0.5}px`,
                background: "linear-gradient(to top, #3b82f6, #60a5fa)",
                left: "50%",
                top: "50%",
                borderRadius: "9999px",
                transformOrigin: "50% calc(100% - 2px)",
                transform: `translate(-50%, -100%) rotate(${hourAngle}deg)`,
                boxShadow: "0 0 8px rgba(59, 130, 246, 0.5)",
              }}
            />

            {/* Minute Hand */}
            <div
              style={{
                position: "absolute",
                width: "4px",
                height: `${OUTER_RADIUS * 0.65}px`,
                background: "linear-gradient(to top, #8b5cf6, #a78bfa)",
                left: "50%",
                top: "50%",
                borderRadius: "9999px",
                transformOrigin: "50% calc(100% - 2px)",
                transform: `translate(-50%, -100%) rotate(${minuteAngle}deg)`,
                boxShadow: "0 0 8px rgba(139, 92, 246, 0.5)",
              }}
            />

            {/* Second Hand */}
            <div
              style={{
                position: "absolute",
                width: "2px",
                height: `${OUTER_RADIUS * 0.75}px`,
                backgroundColor: "#f87171",
                left: "50%",
                top: "50%",
                borderRadius: "9999px",
                transformOrigin: "50% calc(100% - 2px)",
                transform: `translate(-50%, -100%) rotate(${secondAngle}deg)`,
                boxShadow: "0 0 8px rgba(248, 113, 113, 0.5)",
              }}
            />

            {/* Center Pin */}
            <div
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                width: "16px",
                height: "16px",
                background: "linear-gradient(135deg, #3b82f6, #8b5cf6)",
                borderRadius: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 10,
                boxShadow: "0 0 8px rgba(59, 130, 246, 0.5)",
              }}
            />
          </div>
        </div>
      </div>

      {/* Digital Time */}
      <div style={{ textAlign: "center", marginTop: "32px" }}>
        <div
          style={{
            fontSize: "2.25rem",
            fontWeight: "300",
            letterSpacing: "0.05em",
          }}
        >
          {time.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          })}
        </div>
      </div>

      {/* Date and Day */}
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <div
          style={{
            fontSize: "1.25rem",
            fontWeight: "300",
            letterSpacing: "0.05em",
            color: "#94a3b8",
          }}
        >
          {dayOfWeek}, {date}
        </div>
      </div>

      {/* Name and Vehicle */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <div
          style={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            letterSpacing: "0.05em",
            color: "#94a3b8",
            textTransform: "uppercase",
          }}
        >
          {details?.data?.fullName}
        </div>
        <div
          style={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: "#fbbf24",
            marginTop: "8px",
          }}
        >
          {details?.data?.vehicleRegNo}
        </div>
      </div>

      {/* License Status */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <div
          style={{
            fontSize: "1.5rem",
            color:
              licenseStatus === "Active"
                ? "#4ade80"
                : licenseStatus === "Pending Approval"
                ? "#fbbf24"
                : "#ef4444",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{licenseStatus}</span>
        </div>
        
        {licenseStatus === "Expired" || licenseStatus.startsWith("Due in") ? (
          <div style={{ marginTop: "10px" }}>
            <div style={{ color: "#ef4444", fontSize: "1rem" }}>
              {daysUntilLock > 0
                ? `Account will be locked in ${daysUntilLock} day(s).`
                : "Account locked. Please renew your license."}
            </div>
            <button
              onClick={handleAddNewLicense}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Add New License
            </button>
          </div>
        ) : (
          <div style={{ marginTop: "10px" }}>
            <button
              onClick={handleLicenseView}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              View License
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ElegantClock;
